import DocumentsTable from '../components/documentsComp/DocumentsTable';

const Document: React.FC = () => {
  return (
    <div>
      <DocumentsTable />
    </div>
  );
};

export default Document;
